;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.2";import * as Sentry from "@sentry/nextjs";
import { initObservabilityNextjsClient } from "@remi/observability/nextjs-client";

import { BOOT_RELOAD_GUARD_KEY, claimReloadGuard, shouldReloadAfterBootFailure } from "~/utils/stale-build-reload";

let reloadingAfterBootFailure = false;

// Turbopack never retries a chunk the HTML lists as a runtime dependency, so losing one leaves Next unbooted.
// Registered before Sentry so the flag is set by the time Sentry's own handler reports the same error.
const reloadOnceAfterBootFailure = (error: unknown) => {
  if (reloadingAfterBootFailure || !shouldReloadAfterBootFailure({ error, nextGlobal: Reflect.get(window, "next") })) {
    return;
  }
  if (!claimReloadGuard(BOOT_RELOAD_GUARD_KEY, "1")) {
    return;
  }
  reloadingAfterBootFailure = true;
  window.location.reload();
};
window.addEventListener("error", (event) => reloadOnceAfterBootFailure(event.error ?? event.message));
window.addEventListener("unhandledrejection", (event) => reloadOnceAfterBootFailure(event.reason));

initObservabilityNextjsClient({
  sentry: {
    integrations: [Sentry.browserTracingIntegration(), Sentry.extraErrorDataIntegration()],
    beforeSend: (event) =>
      reloadingAfterBootFailure
        ? { ...event, level: "warning", tags: { ...event.tags, recoveredByReload: true } }
        : event,
  },
});

/** @public */
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
